<sbnb-apps-detail-page
  vendorCode="rankbreeze"
  name="Rankbreeze"
  logoTile="/assets/images/apps/rankbreeze.jpg"
  builtBy="Rankbreeze"
  builtByLink="https://rankbreeze.com/"
  [categories]="['Dynamic pricing']"
  [permissions]="[AppPermission.propertyListingRead, AppPermission.reservationRead]"
  email="support@rankbreeze.com"
  [helpArticles]="[
    {
      id: '8186247',
      title: 'How to integrate Rankbreeze with Hospitable to automate dynamic pricing'
    }
  ]">
  <ng-container description>
    <p>
      Rankbreeze's listing optimization & pricing platform connects with Hospitable to bring you the most flexible
      pricing engine possible. Once integrated, you can build the pricing strategy you’ve always dreamed of with
      stackable pricing rules. Overall, Rankbreeze helps you in three main areas: listing optimization, price
      optimization, & market data. Click 'Get Started' to learn more & maximize your bookings today!
    </p>

    <div class="mt-5" style="position: relative; padding-bottom: 56.25%; height: 0">
      <iframe
        src="https://www.youtube.com/embed/AbEa6xJifbo"
        frameborder="0"
        allowfullscreen
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"></iframe>
    </div>

    <sbnb-image-carousel
      class="mt-5"
      [images]="[
        '/assets/images/apps/rankbreeze/screenshot2.jpg',
        '/assets/images/apps/rankbreeze/screenshot1.jpg'
      ]"></sbnb-image-carousel>
  </ng-container>
</sbnb-apps-detail-page>
